<template>
  <div class="moniadd">
    <moduler name="targetingadd" title="新增定向包">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">媒体</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="targeting.mediaId" type="button">
            <Radio :label="16" disabled>腾讯</Radio>
            <Radio :label="32">磁力引擎</Radio>
            <Radio :label="6" disabled>超级汇川</Radio>
            <Radio :label="45" disabled>百度信息流</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <!-- 定向方式 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">定向方式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.intelli_extend_option" type="button">
            <Radio :label="0">自定义定向</Radio>
            <Radio :label="1">智能定向</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">定向包名称</span>
        </Col>
        <Col span="12">
          <input-len v-model="targeting.targetingName" placeholder="最大30个字符，1个中文等于2个字符" :max="30" width="352" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">描述</span>
        </Col>
        <Col span="12">
          <textarea-len v-model="targeting.targetingDesc" placeholder="最大300个字符，1个中文等于2个字符" :max="300" width="352" />
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">账号选择</span>
        </Col>
        <Col span="12">
          <auto-complete
            :data="accountData"
            v-model="targeting.accountIds"
            placeholder="请选择账号"
            @on-select="handleAccount"
            style="width: 280px"
          />
        </Col>
      </Row>

      <!-- 地域 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">地域</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.district" type="button" @on-change="radioChange('cityData')">
            <Radio label="NONE">不限</Radio>
            <Radio label="CITY">按省市</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-show="target.district === 'CITY'">
        <Col span="3">&nbsp;</Col>
        <Col span="14">
          <selecter
            v-model="mult_city"
            :data="target.cityData"
            :title="['省份', '城市']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>

      <!-- 性别 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">性别</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.gender" type="button">
            <Radio :label="0">不限</Radio>
            <Radio :label="2">男</Radio>
            <Radio :label="1">女</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- 年龄 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">年龄</span>
        </Col>
        <Col span="18">
          <RadioGroup v-model="target.ageMode" type="button">
            <Radio label="NONE">不限</Radio>
            <Radio label="CUSTOM">自定义年龄</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.ageMode === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18">
          <Slider v-model="target.age" :marks="marks" :step="1" :min="18" :max="55" style="width: 804px" range />
        </Col>
      </Row>

      <!-- 人群包 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">人群包</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.audienceMode" type="button" @on-change="changeRetarget">
            <Radio label="NONE">不限</Radio>
            <Radio label="AUDIENCE">定向或排除人群</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.audienceMode === 'AUDIENCE'">
        <Col span="3">&nbsp;</Col>
        <Col span="17">
          <retarget
            title="选定人群"
            :data="target.audienceData"
            :payTypeBag="payTypeBag"
            :accounts="accounts"
            :auto="Boolean(target.intelli_extend_option)"
            :currenTab="Boolean(target.intelli_extend_option) ? 'exclude' : 'include'"
            @on-clear="clearRetarget"
            @on-delete="delRetarget"
          />
        </Col>
      </Row>

      <template v-if="!target.intelli_extend_option">
        <!-- 行为兴趣定向-->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">行为兴趣定向</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.behavior_type" type="button" @on-change="resetInterestAction">
              <Radio :label="0">不限</Radio>
              <Radio :label="1">自定义</Radio>
              <Radio :label="2">系统优选</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.behavior_type === 1">
          <Col span="3" class="col-item">
            <span class="item-field">行为</span>
          </Col>
          <Col span="15">
            <!-- 新版 -->
            <action-interest
              v-model="target.action_tags"
              :action-scene="target.action_scene"
              :action-days="target.action_days"
              :strength="target.action_intensity"
              :accounts="[{ id: ksManageId }]"
              :max="100"
              action
              @on-days="setDays"
              @on-scene="setScene"
              @on-intensity="setIntensity('action_intensity', $event)"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.behavior_type === 1">
          <Col span="3" class="col-item">
            <span class="item-field">兴趣</span>
          </Col>
          <Col span="15">
            <!-- 新版 -->
            <action-interest
              v-model="target.word_tags"
              :strength="target.interest_intensity"
              :max="100"
              :accounts="[{ id: ksManageId }]"
              @on-intensity="setIntensity('interest_intensity', $event)"
            />
          </Col>
        </Row>
      </template>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">操作系统版本</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.platform_os" type="button">
            <Radio :label="0">不限</Radio>
            <Radio :label="1">安卓</Radio>
            <Radio :label="2">iOS</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- 安卓版本 -->
      <Row class="row-item" :gutter="12" v-if="target.platform_os === 1">
        <Col span="3" class="col-item">
          <span class="item-field">安卓版本</span>
        </Col>
        <Col span="12">
          <version v-model="target.android_osv" :data="androidVersion" title="安卓版本" />
        </Col>
      </Row>

      <!-- iOS版本 -->
      <Row class="row-item" :gutter="12" v-if="target.platform_os === 2">
        <Col span="3" class="col-item">
          <span class="item-field">iOS版本</span>
        </Col>
        <Col span="12">
          <version v-model="target.ios_osv" :data="iOSVersion" title="iOS版本" />
        </Col>
      </Row>

      <template v-if="!target.intelli_extend_option">
        <!-- 设备品牌 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">设备品牌</span>
          </Col>
          <Col span="17">
            <Mixcheck v-model="target.device_brand_ids">
              <radio-item :label="0">不限</radio-item>
              <check-item v-for="item in deviceBrand" :key="item.id" :label="item.value">
                {{ item.label }}
              </check-item>
            </Mixcheck>
          </Col>
        </Row>

        <!-- 设备价格 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">设备价格</span>
          </Col>
          <Col span="17">
            <Mixcheck v-model="target.device_price">
              <radio-item :label="0">不限</radio-item>
              <check-item v-for="item in devicePrice" :key="item.id" :label="item.value">
                {{ item.label }}
              </check-item>
            </Mixcheck>
          </Col>
        </Row>

        <!-- 网络 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">网络</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.network" type="button">
              <Radio :label="0">不限</Radio>
              <Radio :label="1">WIFI</Radio>
              <Radio :label="2">移动网络</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- APP定向 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">APP定向</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.app_behavior" type="button" @on-change="changeBehavior">
              <Radio :label="0">不限</Radio>
              <Radio :label="1">按APP分类</Radio>
              <Radio :label="2">按APP名称</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.app_behavior === 1">
          <Col span="3">&nbsp;</Col>
          <Col span="17">
            <selecter
              v-model="mult_app"
              :data="target.appData"
              :title="['APP分类']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.app_behavior === 2">
          <Col span="3">&nbsp;</Col>
          <Col span="17">
            <adder
              v-model="target.mult_cate"
              :data="target.categroyData"
              :loading="cating"
              :maxtotal="10"
              :columns="[
                {
                  type: 'selection',
                  width: 60,
                  align: 'center'
                },
                {
                  key: 'name',
                  title: '名称'
                }
              ]"
              @on-select="selectCategroy"
              @on-search="getCategroy"
              @on-delete="delCategroy"
              @on-clear="clearCategroy"
              placeholder="请输入APP名称"
            />
          </Col>
        </Row>
      </template>

      <!-- 过滤已转化用户 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">过滤已转化用户</span>
        </Col>
        <Col span="17">
          <Mixcheck v-model="target.filter_converted_level">
            <radio-item v-for="item in filterConvertLevel" :key="item.id" :label="item.value">
              {{ item.label }}
            </radio-item>
          </Mixcheck>
        </Col>
      </Row>
    </moduler>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="save">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { isArray, findCheck, getNameOfData, clearTagOfData, timeout, isEmpty, getKeyOfData } from '@/common/js/utils'
import validMixin from './mixins/valid-mixin'
import Moduler from '@/components/moduler.vue'
import InputLen from '@/components/input/input-len.vue'
import TextareaLen from '@/components/input/textarea-len.vue'
import ErrorPop from '@/components/error-pop.vue'
import AutoComplete from '@/components/autocomplete/autocomplete'
import Selecter from '@/components/select/selecter.vue'
import Retarget from '@/views/create/kuaishou/components/retarget'
import ActionInterest from '@/views/create/kuaishou_local/components/actioninterest/'
import Version from '@/components/version/'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Adder from '@/components/add/adder'

import cityData from '@/data/kuaishou/city_province'
import { marks, androidVersion, iOSVersion, deviceBrand, devicePrice, filterConvertLevel } from '@/data/kuaishou/datas'

import { adAccount } from '@/api/common.model'
import { addTargeting, updateTargeting, getTargetingDataById, queryManageIdByMedia } from '@/api/manage.model'
import { getAppSearch, getPopulationList, getTargetingTags } from '@/api/kuaishou.model'

export default {
  name: 'KsTarget',
  mixins: [validMixin],
  components: {
    Moduler,
    InputLen,
    TextareaLen,
    AutoComplete,
    ErrorPop: ErrorPop,
    Selecter,
    Retarget,
    ActionInterest,
    Version,
    Mixcheck,
    CheckItem,
    RadioItem,
    Adder
  },
  data() {
    return {
      ksManageId: null,
      targeting: {
        mediaId: 32,
        targetingId: this.$route.query.targetingId,
        accountIds: '',
        targetingName: '',
        targetingDesc: ''
      },
      target: {
        // 定向
        intelli_extend_option: 0, // 是否开启智能定向
        gender: 0, // 性别默认不限
        region: [], // 地域ID列表
        age: [25, 45], // 年龄
        platform_os: 0, // 版本
        android_osv: 3, // 安卓版本
        ios_osv: 6, // iOS版本
        device_brand_ids: 0, // 设备品牌
        device_price: 0, // 设备价格
        network: 0, // 网络
        app_interest_ids: [], // APP行为-按分类
        app_ids: [], // APP行为-按应用
        filter_converted_level: 0, // 过滤已转化
        exclude_population: [], // 定向人群包
        population: [], // 排除人群包
        behavior_type: 0, // 行为兴趣定向
        action_tags: [],
        action_scene: [1, 2, 4],
        action_days: 4,
        action_intensity: 0,
        interest_intensity: 0,

        // 辅助参数
        district: 'NONE',
        ageMode: 'NONE',
        audienceMode: 'NONE',
        mult_cate: [], // 选择的app名称
        categroyData: [],
        app_behavior: 0,

        // 数据源
        cityData: cityData,
        appData: [],
        audienceData: [],
        audiences: [{}]
      },

      accountData: [], // 账号下拉数据
      accountId: 4417, // 获取通用枚举数据时使用
      payTypeBag: [7], // 付费人群包类型
      cating: null,
      asying: null,
      show: null,
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      // 枚举值
      marks, // 年龄标志
      androidVersion,
      iOSVersion,
      deviceBrand,
      devicePrice,
      filterConvertLevel
    }
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    mult_city() {
      return findCheck(this.target.cityData)
    },
    mult_app() {
      return findCheck(this.target.appData)
    },
    accounts() {
      if (this.targeting.accountIds) return [{ id: this.targeting.accountIds }]
      else return this.targeting.accountIds
    }
  },
  methods: {
    changeBehavior() {
      this.radioChange('appData')
      this.target.categroyData = []
      this.target.mult_cate = []
    },
    resetDataSource() {
      // 人群包
      this.target.audienceMode = 'NONE'
      this.target.audiences = [{}]
      this.target.audienceData = []

      // APP定向
      this.target.app_behavior = 0
      this.target.appData = []
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      // 递归选中
      const deepSelectAll = (items) => {
        items.some((ret) => {
          if (ret.children && ret.children.length) deepSelectAll(ret.children)
          this.$set(ret, 'check', check)
        })
      }
      deepSelectAll(data)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    radioChange(key) {
      clearTagOfData(this.target[key], this)
    },
    handleAccount(meta) {
      this.$set(this.targeting, 'accountIds', meta.id)
      this.resetInterestAction()
      this.resetDataSource()
      this.changeBehavior()
      this.preloadData()
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    // 清空行为兴趣定向
    resetInterestAction() {
      this.target.action_scene = [1, 2, 4]
      this.target.action_days = 4
      this.target.action_intensity = 0
      this.target.interest_intensity = 0
      this.target.action_tags = []
      this.target.word_tags = []
    },
    // 定向人群切换
    changeRetarget(val) {
      if (val === 'NONE') {
        this.target.audiences.forEach((ret) => {
          if (ret.audienceData && isArray(ret.audienceData)) {
            ret.audienceData.forEach((met) => {
              this.$set(met, 'select', '')
            })
          }
        })
      }
    },
    getCategroy(keyword) {
      const params = { ad_account_id: this.targeting.accountIds, appName: keyword }
      this.cating = true
      getAppSearch(params).then((data) => {
        this.cating = false
        if (data) {
          this.target.categroyData = data.map((ret) => {
            return {
              id: ret.app_id,
              name: ret.app_name
            }
          })
        }
      })
    },
    selectCategroy(val) {
      const app_ids = this.target.categroyData.map((ret) => ret.id)
      const noSourceItem = this.target.mult_cate.filter((ret) => !app_ids.includes(ret.id))
      noSourceItem.push(...val)
      this.target.mult_cate = noSourceItem
    },
    delCategroy(ids) {
      if (isArray(ids)) {
        ids.forEach((met) => {
          const index = this.target.mult_cate.findIndex((ret) => ret.id === met)
          if (index > -1) {
            this.target.mult_cate.splice(index, 1)
          }
        })
      }
    },
    clearCategroy() {
      this.target.mult_cate = []
    },
    setDays(val) {
      this.target.action_days = val
    },
    setScene(val) {
      this.target.action_scene = val
    },
    setIntensity(prop, val) {
      this.target[prop] = val
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    },
    jump() {
      this.$router.push({ name: 'targetingslist' })
    },
    getData() {
      // 加载动画
      this.show = false
      this.$Spin.show()
      getTargetingDataById({ targetingId: this.targeting.targetingId })
        .then((data) => {
          if (data) {
            const { targetingId, targetingName, targetingDesc, targetingParamJson: target, accountIds } = data
            this.targeting = Object.assign({}, this.targeting, {
              targetingId,
              targetingName,
              targetingDesc,
              accountIds: Number(accountIds)
            })
            if (target) {
              target.audienceData = target.audiences[0].audienceData
              Object.assign(this.target, target)
            }
            timeout(2000).then(() => {
              this.show = true
              this.$Spin.hide()
            })
          }
        })
        .catch((err) => {
          console.log(err)
          this.$Message.error(err)
        })
    },
    decompile(Ids, data) {
      const deepSelect = (children) => {
        children.forEach((ret) => {
          if (ret.children && ret.children.length) {
            deepSelect(ret.children)
          } else {
            // 如有子级未选中父级的选中无意义
            this.$set(ret, 'check', true)
          }
        })
      }
      if (!isArray(Ids) || !Ids.length) this.radioChange(data)
      else {
        Ids.forEach((ret) => {
          const item = getKeyOfData(this.target[data], 'id', ret)
          if (item.children && item.children.length) {
            deepSelect(item.children)
          }
          this.$set(item, 'check', true)
        })
      }
    },
    decompileKey(vals, data) {
      const deepSelect = (children) => {
        children.forEach((ret) => {
          if (ret.children && ret.children.length) {
            deepSelect(ret.children)
          } else {
            this.$set(ret, 'check', true)
          }
        })
      }
      if (!isArray(vals) || !vals.length) this.radioChange(data)
      else {
        vals.forEach((ret) => {
          const item = getKeyOfData(this.target[data], 'key', ret)
          if (item.children && item.children.length) {
            deepSelect(item.children)
          }
          this.$set(item, 'check', true)
        })
      }
    },
    valid() {
      const rules = [
        {
          name: 'targeting/targetingName',
          require: true,
          min: 1,
          max: 30,
          desc: '定向包名称'
        },
        {
          name: 'mult_city',
          require: true,
          relyon: 'target/district',
          relyvalue: 'CITY',
          min: 1,
          desc: '地域'
        },
        {
          name: 'mult_app',
          require: true,
          relyon: 'target/app_behavior',
          relyvalue: 1,
          min: 1,
          desc: 'APP定向-按APP分类'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid() {
      const err = []
      const includes = this.target.audienceData.filter((ret) => ret.select === 'include')
      const excludes = this.target.audienceData.filter((ret) => ret.select === 'exclude')
      // 人群包
      if (this.target.audienceMode === 'AUDIENCE' && !includes.length && !excludes.length) {
        err.push({ feild: '人群包', msg: '请选择人群包，或是切换成不限' })
      }
      // 账号
      if ((includes.length || excludes.length) && isEmpty(this.targeting.accountIds)) {
        err.push({ feild: '人群包', msg: '账号不能为空' })
      }
      // 行为兴趣意向
      if (this.target.behavior_type === 1) {
        const { action_tags, word_tags } = this.target
        const keyword = action_tags
          .filter((ret) => ret.type === 'KEYWORD')
          .map((ret) => {
            return {
              id: ret.id,
              name: ret.name
            }
          })
        const action_label = action_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
        const interest_label = word_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
        if (!keyword.length && !action_label.length && !interest_label.length) {
          err.push({ feild: '行为兴趣', msg: '行为兴趣必选其一，或是切换成不限' })
        }
      }
      // APP定向-按APP名称
      if (this.target.app_behavior === 2) {
        if (!this.target.mult_cate.length) {
          err.push({ feild: 'APP定向', msg: '请选择APP名称，或是切换成不限' })
        }
      }
      return err
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const target = JSON.parse(JSON.stringify(this.target))
      // 组合提交参数
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: target,
        targetingParam: JSON.stringify(target),
        accountIds: String(this.targeting.accountIds)
      })

      this.$Spin.show()
      this.loading = true
      updateTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '修改成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    submit() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const target = JSON.parse(JSON.stringify(this.target))
      // 组合提交参数
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: target,
        targetingParam: JSON.stringify(target),
        accountIds: String(this.targeting.accountIds)
      })

      this.$Spin.show()
      this.loading = true
      addTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    getManageIdByMedia() {
      queryManageIdByMedia().then((manageIdData) => {
        if (manageIdData && isArray(manageIdData)) {
          this.ksManageId = manageIdData.filter((m) => m.mediaId === 32).pop().manageId
        }
      })
    },
    preloadData() {
      const { accountIds: accountId } = this.targeting
      this.$Spin.show()
      Promise.all([
        getPopulationList({ ad_account_id: accountId }),
        getTargetingTags({ ad_account_id: accountId, type: 'APP_INTEREST_ID' })
      ]).then((data) => {
        const [audienceData, appInterest] = data
        if (isArray(audienceData)) {
          this.target.audiences[0].account_id = accountId
          this.target.audiences[0].audienceData = audienceData.map((ret) => {
            return {
              id: ret.orientation_id,
              key: ret.orientation_id,
              vaule: ret.orientation_name,
              name: ret.orientation_name,
              extend: ret.cover_num,
              type: ret.population_type,
              code: ret.third_platform_code
            }
          })
          this.target.audienceData = this.target.audiences[0].audienceData
        }

        this.target.appData = isArray(appInterest) ? appInterest.map((app) => ({ ...app, value: app.name })) : []

        this.show = true
        this.$Spin.hide()
      })
    }
  },
  watch: {
    'target.intelli_extend_option': {
      handler(val) {
        if (val) {
          this.target.audienceData.forEach((item) => {
            item.select === 'include' && this.$set(item, 'select', null)
          })
        }
        if (val) {
          // 切换为智能定向时重置多余定向参数
          this.$set(this.target, 'behavior_type', 0)
          this.$set(this.target, 'device_brand_ids', 0)
          this.$set(this.target, 'device_price', 0)
          this.$set(this.target, 'network', 0)
          this.$set(this.target, 'app_behavior', 0)
        }
      }
    }
  },
  created() {
    adAccount({
      mediaId: this.targeting.mediaId,
      authFlag: 1
    })
      .then((data) => {
        if (isArray(data) && data.length) {
          this.accountData = data.map((ret, id) => {
            if (!id) this.targeting.accountIds = Number(ret.id)
            return { id: ret.id, name: ret.name }
          })
          // 获取管家账号
          this.getManageIdByMedia()

          if (this.targeting.targetingId) this.getData()
          else this.preloadData()
        }
      })
      .catch((err) => {
        this.$Message.error('获取账号接口报错：' + err)
      })
  }
}
</script>
<style lang="scss" scoped>
.moniadd {
  height: calc(100% - 40px);
  overflow: auto;

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

/* 单选框覆盖 */
.ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

.ivu-tabs-bar {
  margin-bottom: 0;
}

/* 表单选项 */
.row-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 32px;

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
    line-height: 32px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }
}

.ivu-poptip-rel {
  width: inherit;
}

/* tags 超长处理 */
::v-deep .ivu-tag {
  .ivu-icon-ios-close {
    top: 3px;
    float: right;
  }

  .ivu-tag-text {
    max-width: 80%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.ivu-tabs-mini {
  .ivu-tabs-bar {
    margin-bottom: 0;
  }

  .ivu-tabs-tab {
    padding: 8px;
  }
}
</style>
